import { MutableRefObject } from 'react';
import { GridRowData } from '@material-ui/x-grid';
import { useSelector } from 'react-redux';
import DatagridHoverTooltip from 'src/components/Datagrid/DatagridHoverTooltip';
import { t } from 'src/lib/language';
import { fetchCampaignPledgedTotal } from 'src/redux/actions/campaignStatisticsActions';
import { Store } from 'src/redux/Store';

interface Props {
  containerRef: MutableRefObject<HTMLDivElement | null>;
  rows: GridRowData[];
  reloadKey?: unknown;
}

const DatagridFundraisingTooltip = (props: Props) => {
  const { containerRef, rows, reloadKey } = props;
  const lang = useSelector((state: Store) => state.language.language ?? 'en');
  const organisationId = useSelector((state: Store) => state.currentOrganisation.id);
  const currencyId = useSelector((state: Store) => state.currentOrganisation.currencyId);
  const currencies = useSelector((state: Store) => state.data.currencies);

  const currencyCode = currencies.find((currency) => currency.id === currencyId)?.name
    ?? 'CAD';
  const locale = lang === 'fr' ? 'fr-CA' : 'en-US';

  const formatValue = (value: unknown): string => (
    Number(value ?? 0).toLocaleString(locale, {
      style: 'currency',
      currency: currencyCode,
    })
  );

  const loadContent = async (row: GridRowData) => {
    const eventId = Number(row.id);
    const pledged = await fetchCampaignPledgedTotal(organisationId, String(eventId));
    const pledgedValue = Number.isNaN(pledged) ? '—' : formatValue(pledged);

    return [
      `${t(lang, 'fields.events.goal')}: ${formatValue(row['events.goal'])}`,
      `${t(lang, 'fields.events.raised')}: ${formatValue(row['events.raised'])}`,
      `${t(lang, 'fields.events.pledged')}: ${pledgedValue}`,
    ].join(' · ');
  };

  return (
    <DatagridHoverTooltip
      containerRef={containerRef}
      rows={rows}
      reloadKey={reloadKey}
      cacheKey={organisationId}
      isRowSupported={() => true}
      loadContent={loadContent} />
  );
};

export default DatagridFundraisingTooltip;
